import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, HiddenSpan, ExternalLink } from 'components'
import * as Types from 'types'
import { getFormWideErrorMessage, useCommunity } from 'utils'

import { SchoolPartnershipForm } from '../forms'

const propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  schoolOptions: PropTypes.arrayOf(Types.searchSuggestion).isRequired,
}

const defaultProps = {
  schoolOptions: [],
}

function AddSchoolPartnershipModal({
  onClose,
  schoolOptions,
  onSubmit,
  onSubmitSuccess,
}) {
  const [formWideError, setFormWideError] = useState(null)
  const [submitFailCount, setSubmitFailCount] = useState(0)

  const community = useCommunity()

  return (
    <Modal onClose={onClose}>
      <h2>Add New Partnership</h2>
      <p className="s-xsmall">
        If you don't see the school you're looking for, please contact{' '}
        <ExternalLink href={`mailto:${community.artistSupportEmail}`}>
          {community.artistSupportEmail}
        </ExternalLink>
        .
      </p>
      <div className="modal-content">
        <div role="alert" aria-atomic>
          {formWideError && (
            <p className="full-error-message">
              {formWideError} <HiddenSpan>{submitFailCount}</HiddenSpan>
            </p>
          )}
        </div>
        <SchoolPartnershipForm
          schoolOptions={schoolOptions}
          onSubmit={onSubmit}
          onSubmitSuccess={onSubmitSuccess}
          onSubmitFail={(errors, _, submitError) => {
            setSubmitFailCount((sfc) => sfc + 1)
            const msg = getFormWideErrorMessage(errors, submitError)
            setFormWideError(msg)
          }}
        />
      </div>
    </Modal>
  )
}

AddSchoolPartnershipModal.propTypes = propTypes
AddSchoolPartnershipModal.defaultProps = defaultProps

export default AddSchoolPartnershipModal
